import { Grid, styled } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors';
import { formatMoney } from '../../../utils/stringUtils';
import { RewardTableProps } from './ProductPageDialogType';

const Container = styled('div')({
  width: 340,
  marginLeft: 'auto',
  marginRight: 'auto',
  '.row': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '7.5px 0',
    ':nth-last-of-type(2)': {
      paddingBottom: 20,
    },
  },
  '.total-row': {
    fontWeight: 600,
    borderTop: `1px solid ${brandclub_colors.blueWhiteBorder}`,
    padding: '20px 0 15px',
  },
});

export const RewardTable = ({ rows, containerStyle = {} }: RewardTableProps) => {
  const totalRewards = rows.reduce((acc, [, amount]) => acc + amount, 0);

  return (
    <Container style={containerStyle}>
      {rows.map((row, index) => (
        <Grid key={index} container className="row">
          <Grid item>{row[0]}</Grid>
          <Grid item>{formatMoney(row[1])}</Grid>
        </Grid>
      ))}
      <Grid container className="row total-row">
        <Grid item>Total rewards</Grid>
        <Grid item>{formatMoney(totalRewards)}</Grid>
      </Grid>
    </Container>
  );
};
